import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

/** Fountain-pen nib (Figma-style pen tool icon). */
export const PenIcon = React.memo(function PenIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.85 1.44a.55.55 0 0 1 .71.71l-2.03 6.09a.55.55 0 0 1-.26.31l-3.72 2.03a.55.55 0 0 1-.65-.09L4.51 8.1a.55.55 0 0 1-.09-.65l2.03-3.72a.55.55 0 0 1 .31-.26l6.09-2.03Z"
        stroke={color}
        strokeWidth="1"
        strokeLinejoin="round"
      />
      <circle cx="8.1" cy="6.9" r="1.05" stroke={color} strokeWidth="0.9" />
      <path
        d="M7.2 7.8 1.9 13.1"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  );
});
